module.exports = __webpack_public_path__ + "static/media/celluma.5ff22b73.png";